import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DatatableComponent, DataTableDataSource, HelpMessage, WorkTypeService} from '@cas-hub/acabim-common-client';
import {DatePipe} from '@angular/common';
import {WorkTypeTable} from '../work-order.model';
import {map} from 'rxjs/operators';
import {WorkOrderTypesDataSource} from '../classes/work-type-data-source.class';
import {Observable} from 'rxjs';

@Component({
  selector: 'acabim-admin-work-order-type-management',
  templateUrl: './work-order-type-management.component.html',
  styleUrls: ['../styles.scss', './work-order-type-management.component.scss']
})
export class WorkOrderTypeManagementComponent implements OnInit, OnDestroy {
  @ViewChild('dataTable') public dataTable!: DatatableComponent;
  addWorkType = false;
  dataTableSources: DataTableDataSource<any>[] = [];
  isLoading = false;
  loadDetails = false;
  nullDate: Date = new Date('0001-01-01T00:00:00');
  selectedDetails: WorkTypeTable | null = null;
  totalRecords = 0;
  helpMessage: HelpMessage = {
    message: 'Work Types are used in work order management for any project'
  };

  constructor(
      private readonly datePipe: DatePipe,
      private readonly workTypeService: WorkTypeService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  ngOnDestroy(): void {}

  getData(): void {
    this.dataTableSources[0] = new WorkOrderTypesDataSource(
        '',
        this.dataRefresher(),
        undefined,
        () => {this.isLoading = false; },
        action => {}
    );
  }

  private dataRefresher(): () => Observable<WorkTypeTable[]> {
    return () => {
      return this.workTypeService.getWorkTypes().pipe(map(data => {
        this.isLoading = false;
        return data.map(d => {
          const lmAsDate = d.last_modified ? new Date(d.last_modified) : null;
          const lmDate = lmAsDate && lmAsDate > this.nullDate ? this.datePipe.transform(lmAsDate, 'dd/MM/yyyy') as string : null;
          const out: WorkTypeTable = {
            ...d,
            cbi_group_display:  d.cbi_group ? d.cbi_group.id.toString() + ' – ' + d.cbi_group.name : '',
            status_display: d.status === 1 ? 'Active' : 'Inactive',
            last_modified_display: lmDate
          };
          return out as WorkTypeTable;
        });
      }));
    };
  }

  add(): void {
    this.addWorkType = true;
  }

  closeDetailsModal(value: any) {
    if (!value) {
      this.selectedDetails = null;
    }
    this.loadDetails = value;
  }

  closeAddModal(value: any) {
    this.addWorkType = value;
  }

  setSelectedDetails(value: any) {
    this.selectedDetails = value;
  }

  completeDetailsModal(value: any) {
    if (value) {
      this.getData();
    }
    this.addWorkType = false;
    this.selectedDetails = null;
    this.loadDetails = false;
    this.dataTable.requestImmediateDataRefresh();
  }

  completeAddModal(value: any) {
    if (value) {
      this.getData();
    }
    this.selectedDetails = null;
    this.addWorkType = false;
    this.dataTable.requestImmediateDataRefresh();
  }

  showDetails(rowData: any): void {
    this.loadDetails = true;
  }

} // end of class
